export default {
	FIRST: 'first',
	SECOND: 'second',
};